import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import { ExpansionPanel, ExpansionPanelDetails } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  details: {
    flexDirection: 'column',
    marginLeft: theme.spacing(2)
  }
}));

export default function DetalhesFiliado(props) {
  const classes = useStyles();
  const { visitaFiliado, pedido } = props;

  return (
    <ExpansionPanel>
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Grid
              container
              spacing={1}
            >
              <Grid
                item
                md={3}
                sm={3}
                xs={3}
              >
                <Typography>Nome:</Typography>

              </Grid>
              <Grid
                item
                md={9}
                xs={9}
                xs={9}
              >
                <Typography><b>{visitaFiliado.filiado.nome}</b></Typography>
              </Grid>
              <Grid
                item
                md={3}
                sm={3}
                xs={3}
              >
                <Typography>RG:</Typography>

              </Grid>
              <Grid
                item
                md={9}
                xs={9}
                xs={9}
              >
                <Typography><b>{visitaFiliado.filiado.rg}</b></Typography>
              </Grid>
              <Grid
                item
                md={3}
                sm={3}
                xs={3}
              >
                <Typography>CPF:</Typography>

              </Grid>
              <Grid
                item
                md={9}
                xs={9}
                xs={9}
              >
                <Typography><b>{visitaFiliado.filiado.cpf}</b></Typography>
              </Grid>
              <Grid
                item
                md={3}
                sm={3}
                xs={3}
              >
                <Typography>Email:</Typography>

              </Grid>
              <Grid
                item
                md={9}
                xs={9}
                xs={9}
              >
                <Typography><b>{visitaFiliado.filiado.email}</b></Typography>
              </Grid>


            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
          >
            <Grid
              container
            >
              <Grid
                item
                md={3}
                sm={3}
                xs={3}
              >
                <Typography>Anuidade:</Typography>
              </Grid>
              <Grid
                item
                md={9}
                xs={9}
                xs={9}
              >
                <Typography><b>{moment(visitaFiliado.filiado.validadeAnuidade).format('DD/MM/YYYY hh:mm')}</b></Typography>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );

}
